import styled, { css } from 'styled-components'

import { coarsePointerNoBackdropBlur } from './coarsePointerNoBackdropBlur'

const glassSurface = css`
  border: 1px solid var(--border);
  background-color: color-mix(in srgb, var(--card) 50%, transparent);
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  ${coarsePointerNoBackdropBlur}
`

export const GlassButtonWell = styled.div`
  overflow: hidden;
  border-radius: var(--radius);
  ${glassSurface}
`

export const GlassPill = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.375rem;
  border-radius: 9999px;
  user-select: none;
  ${glassSurface}
`
